import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { UserString, UserStringDto } from '@/types';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  BASEURL = `${environment.api.authUrl}/keycloak/users`;
  ROLESURL = `${environment.api.authUrl}/keycloak/roles`;
  private dtoSubject = new BehaviorSubject<UserStringDto>({} as UserStringDto);
  private responseSubject = new BehaviorSubject<UserString>({} as UserString);

  httpClient = inject(HttpClient);

  getUsers(): Observable<UserString[]> {
    return this.httpClient.get<UserString[]>(`${this.BASEURL}`);
  }

  getUserById(id: string): Observable<UserString> {
    return this.httpClient.get<UserString>(`${this.BASEURL}/${id}`);
  }

  addUser(user: UserStringDto): Observable<UserString> {
    return this.httpClient.post<UserString>(`${this.BASEURL}`, user);
  }

  updateUser(id: string, user: UserStringDto): Observable<UserString> {
    return this.httpClient.put<UserString>(`${this.BASEURL}/${id}`, user);
  }

  deleteUser(id: string): Observable<UserString> {
    return this.httpClient.delete<UserString>(`${this.BASEURL}/${id}`);
  }

  getAllRoles() {
    return this.httpClient.get<any[]>(`${this.ROLESURL}`);
  }

  set(key: 'dto' | 'response', value: UserStringDto | UserString) {
    if (key === 'dto') this.dtoSubject.next(value as UserStringDto);
    if (key === 'response') this.responseSubject.next(value as UserString);
  }

  get(key: 'dto' | 'response'): UserStringDto | UserString {
    if (key === 'dto') return this.dtoSubject.getValue();
    if (key === 'response') return this.responseSubject.getValue();
    return {} as UserStringDto;
  }

  reset() {
    this.dtoSubject.next({} as UserStringDto);
    this.responseSubject.next({} as UserString);
  }

  resetPassword(id: string): Observable<any> {
    return this.httpClient.post(`${environment.api.authUrl}/keycloak/${id}/reset-password`, {});
  }

  enableUser(userId: string, enabled: boolean) {
    return this.httpClient.put(`${this.BASEURL}/${userId}/enable?enabled=${enabled}`, {});
  }
}
